import React, { useState, useEffect } from "react";
import RopeBlue from "../../../../../Asset/icon/rope_blue.svg";
import { Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../../../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import { getYachtTypesDetail } from "../../../../../redux/YachtTypes/YachtTypesSlice";
import { useTranslation } from "react-i18next";
import "./customCheckbox.css";

const YachtType = ({ yachtTypes, setYachtTypeFilter, preYachtTypes }) => {
  const { t } = useTranslation();
  const [selectedTypes, setSelectedTypes] = useState(Array.from(preYachtTypes));
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      dispatch(getYachtInfoSellingPriceRatePlanListDetail({})),
      dispatch(getYachtTypesDetail({})),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  const YachtTypes = loading
    ? []
    : todos.YachtInfoSellingPriceRatePlanListSlice
      .YachtInfoSellingPriceRatePlanList.results;

  useEffect(() => {
    setYachtTypeFilter(selectedTypes);
  }, [selectedTypes, setYachtTypeFilter]);

  const handleCheckboxChange = (event) => {
    const selectedType = event.target.value;
    setSelectedTypes((prevSelected) =>
      prevSelected.includes(selectedType)
        ? prevSelected.filter((type) => type !== selectedType)
        : [...prevSelected, selectedType]
    );
  };

  const handleClearFilter = () => {
    setSelectedTypes([]);
  };

  return (
    <div className="d-flex flex-column align-items-center position-relative">
      <div className="mb-4">
        <div
          className="absolute-left-text"
        >
          {t("Yacht Type")}
        </div>
        <div
          className="absolute-right-link"
        >
          <a onClick={handleClearFilter}>{t("CLEAR")}</a>
        </div>
      </div>
      <div className="mt-4 w-80-percent">
        <Form className="d-flex flex-column align-items-start ">
          {yachtTypes.map((type) => (
            <Form.Check
              className="custom-checkbox"
              key={type}
              type="checkbox"
              id={type}
              //   label={type}
              label={
                <div className="text-left">
                  {type} (
                  {
                    YachtTypes.filter(
                      (yacht) => yacht.value_yachtTypes === type
                    ).length
                  }
                  )
                </div>
              }
              value={type}
              onChange={handleCheckboxChange}
              checked={selectedTypes.includes(type)}
            />
          ))}
        </Form>
      </div>
      <div>
        <img className="m-4" draggable={false} src={RopeBlue} alt="RopeBlue" />
      </div>
    </div>
  );
};

export default YachtType;
